<template>
  <div>
    <home-mobile
      v-if="isMobile"
      :contents="contents"
      :time-elapsed="timeElapsed"
      :challenges="challenges"
    />
    <home-desktop
      v-else
      :contents="contents"
      :time-elapsed="timeElapsed"
      :challenges="challenges"
    />
  </div>
</template>

<script>
  import Background from '@/assets/Background.png';
  import ChallengesController from '@/controllers/ChallengesController';

  export default {
    name: 'Homes',

    components: {
      HomeDesktop: () => import('./HomeDesktop.vue'),
      HomeMobile: () => import('./HomeMobile.vue'),
    },

    props: ['isMobile'],

    data: () => ({
      Background,
      contents: [
        'HAPPY \nNEWJEANS \nEVERYONE!',
        '9:00AM EST / "HAPPY NEWJEANS"',
        '',
        'Win KPOP Album & Merch!',
        'WIN \nYOUR \nBTS \nMERCH',
        'NEW \nPREMIUM \nPACK IS NOW \nAVAILBLE',
      ],
      challenges: [],
      timeElapsed: 0,
      timerInterval: undefined,
      timeLimit: 10000,
    }),

    computed: {},

    mounted() {
      this.getChallenges();
      this.startTimer();
    },

    methods: {
      getChallenges: async function() {
        try {
          this.challenges = await ChallengesController.getChallenges();
        } catch (err) {
          this.$emit('handleError', err);
        }
      },
      startTimer() {
        this.timerInterval = setInterval(() => {
          if (++this.timeElapsed === this.timeLimit) {
            clearInterval(this.timerInterval);
          }
        }, 1000);
      },
    },
  };
</script>

<style scoped>
  .background {
    background-size: cover;
    background-repeat: no-repeat;
  }
</style>
